export const USE_INFOR_USER = 'USE_INFOR_USER';
